import React from 'react';
import LogoLinktivity from '@link/admin/assets/logo-linktivity.svg?react';
import User from './User';

import styles from './header.module.css';

const Header: React.FC = () => (
  <header className={styles.header}>
    <div className={styles.inner}>
      <a href="/" className={styles.logo}>
        <LogoLinktivity className={styles.logoImage} />
      </a>
      <User />
    </div>
  </header>
);

export default Header;
